<template lang="pug">
.app-header.w(:class="{'show-nav': showNav}")
  router-link.logo(:to="'home'")
  .close(v-if="isMobile && showNav", @click="showNav = false")
  .nav
    a(
      v-for="(item, index) in navList",
      @click="selectNav(item)"
      :class="[{'router-link-active': isActive(item.path)}, 'delay' + index]",
    ) {{item.title}}
    a(
      href="http://en.flyingwings.cn/"
      class="delay6"
    ) English
  .menu(v-if="isMobile && !showNav", @click="showNav = true")
</template>

<script>
export default {
  data () {
    return {
      showNav: false,
      currentPath: '/home',
      navList: [
        { path: '/home', title: '首页' },
        { path: '/robot3s/info', title: '维拉3S' },
        { path: '/robot3/info', title: '维拉3' },
        { path: '/robot2s/info', title: '维拉2S' },
        { path: '/about', title: '关于我们' },
        { path: '/news', title: '新闻动态' },
        { path: '/service', title: '服务' },
      ]
    }
  },
  computed: {},
  methods: {
    selectNav (item) {
      this.currentPath = item.path
      this.$router.push({path: item.path})
      this.showNav = false
    },
    isActive (path) {
      return this.$route.fullPath.split('/')[1].split('#')[0] === path.split('/')[1].split('#')[0]
    }
  },
  created () {
  },
}
</script>

<style lang="stylus">
@import 'base/base'
.app-header
  position relative
  height 90px
  line-height 90px
  overflow hidden
  .logo
    float left
    width 190px
    height 90px
    background url('../assets/web/logo.png') no-repeat left center
  .nav
    float right
    a
      cursor pointer
      display inline-block
      font-size 16px
      margin 0 38px
      color #000
      &:hover,
      &.router-link-active
        color #3ec1bd
.is-mobile
  .app-header
    position relative
    height r(90)
    line-height r(90)
    &.show-nav
      z-index 20
      position fixed
      top 0
      left 0
      right 0
      bottom 0
      z-index 30
      height inherit
      background #393d3f
      .logo
        left r(255)
      .nav
        display block
    .logo
      position absolute
      left r(25)
      top 0
      height r(90)
      width r(240)
      background-size r(180) auto
      background-position center
      transition 1s left
    .menu
      position absolute
      right r(25)
      top 0
      width r(40)
      height r(90)
      background url('../assets/mobile/icon-menu.png') no-repeat center
      background-size 100% auto
    .close
      position absolute
      right r(25)
      top 0
      width r(30)
      height r(90)
      background url('../assets/mobile/icon-close.png') no-repeat center
      background-size 100% auto
    .nav
      float inherit
      margin-top r(120)
      text-align center
      display none
      a
        @extend .fadeDown
        display block
        width r(400)
        margin 0 auto
        font-size r(30)
        color #fff
        border-bottom 1px solid #444749
        &:hover,
        &.router-link-active
          color #3ec1bd
</style>



// WEBPACK FOOTER //
// src/components/app-header.vue